import httpClient from '@shared/lib/httpClient';
import { ENDPOINTS } from '@shared/services/api/endpoints';

/**
 * Firm-subdomain API calls, shared across features (signup in `auth`, the owner subdomain editor in
 * `profile`). Lives in `shared/` so no feature imports another feature's service. The server owns
 * the suffix list, normalization, and uniqueness — these are thin transport wrappers.
 */

/**
 * Check a firm subdomain: validates format, reports availability, and returns a
 * unique suggestion when taken. Mirrors the server-side generation algorithm.
 * @param {string} subdomain - The subdomain to check
 * @returns {Promise<{ data: { normalized: string, available: boolean, exists: boolean, error?: string, suggestion?: string } }>}
 */
export async function checkSubdomain(subdomain) {
  const response = await httpClient.get(ENDPOINTS.ACCOUNT.CHECK_SUBDOMAIN, { params: { subdomain } });
  return response.data;
}

/**
 * Generate a firm subdomain from a company name. The server owns the suffix list,
 * normalization, and uniqueness — the client only populates the field with the result.
 * @param {string} companyName - The company name to derive the subdomain from
 * @returns {Promise<{ data: { subdomain: string } }>}
 */
export async function generateSubdomain(companyName) {
  const response = await httpClient.get(ENDPOINTS.ACCOUNT.GENERATE_SUBDOMAIN, { params: { companyName } });
  return response.data;
}
